import "./cart-item.scss";
import { useContext, useState } from "react";
import { ShopContext } from "../../context/ShopContext";

function CartItem({ item }) {
  const { id } = item;
  const { addToCart, removeFromCart, cartItems } = useContext(ShopContext);

  const sizes = ["S", "M", "L", "XL"];
  const [selectedSize, setSelectedSize] = useState("");

  return (
    <div className="cart-item">
      <div className="cart-item__left">
        <img src={item.img} alt={item.alt} />
      </div>
      <div className="cart-item__right">
        <div className="cart-item__right__top">
          <h2>{item.title}</h2>
          <p>{item.desc}</p>
        </div>
        <div className="cart-item__right__bottom">
          <h3>
            Quantity:
            <span className="cart-item__right__bottom__qty">
              <span onClick={() => removeFromCart(id)}> - </span>
              {cartItems[id]}
              <span onClick={() => addToCart(id)}> + </span>
            </span>
          </h3>
          <div className="cart-item__right__bottom__size">
            Size:
            {sizes.map((size) => {
              return (
                <button
                  onClick={() => setSelectedSize(size)}
                  className={`${selectedSize === size ? "selected" : ""}`}
                  key={size}
                >
                  {size}
                </button>
              );
            })}
          </div>
          <h3 className="cart-item__right__bottom__price">$ {item.price}</h3>
        </div>
      </div>
    </div>
  );
}

export default CartItem;
